import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { UtxoBlockPage } from './pages/UtxoBlockPage';
import { AuxpowPage } from './pages/AuxpowPage';
import { ChainLocksPage } from './pages/ChainLocksPage';
import { QuorumsPage } from './pages/QuorumsPage';
import { MinersPage } from './pages/MinersPage';
import { MinerBlocksPage } from './pages/MinerBlocksPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { NetworkStatusBar } from './components/NetworkStatusBar';
import { Footer } from './components/Footer';

export const App = () => (
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <>
      <div className="container">
        <header>
          <h1>Syscoin Multi-Chain Status</h1>
          <NetworkStatusBar />
        </header>
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route
              path="/utxo/block/:blockHash"
              element={
                <>
                  <Link
                    to="/"
                    style={{
                      fontSize: '1.2em',
                      color: '#81C784',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                      display: 'inline-block',
                      marginBottom: '1rem',
                    }}
                  >
                    ← Home
                  </Link>
                  <UtxoBlockPage />
                </>
              }
            />
            <Route
              path="/auxpow/:btcBlockHash"
              element={
                <>
                  <Link
                    to="/"
                    style={{
                      fontSize: '1.2em',
                      color: '#81C784',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                      display: 'inline-block',
                      marginBottom: '1rem',
                    }}
                  >
                    ← Home
                  </Link>
                  <AuxpowPage />
                </>
              }
            />
            <Route
              path="/chainlocks"
              element={
                <>
                  <Link
                    to="/"
                    style={{
                      fontSize: '1.2em',
                      color: '#81C784',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                      display: 'inline-block',
                      marginBottom: '1rem',
                    }}
                  >
                    ← Home
                  </Link>
                  <ChainLocksPage />
                </>
              }
            />
            <Route
              path="/mining"
              element={
                <>
                  <Link
                    to="/"
                    style={{
                      fontSize: '1.2em',
                      color: '#81C784',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                      display: 'inline-block',
                      marginBottom: '1rem',
                    }}
                  >
                    ← Home
                  </Link>
                  <MinersPage />
                </>
              }
            />
            <Route
              path="/mining/pool/:mempoolId"
              element={
                <>
                  <Link
                    to="/mining"
                    style={{
                      fontSize: '1.2em',
                      color: '#81C784',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                      display: 'inline-block',
                      marginBottom: '1rem',
                    }}
                  >
                    ← Mining Pools
                  </Link>
                  <MinerBlocksPage />
                </>
              }
            />
            <Route
              path="/quorums"
              element={
                <>
                  <Link
                    to="/"
                    style={{
                      fontSize: '1.2em',
                      color: '#81C784',
                      textDecoration: 'none',
                      fontWeight: 'bold',
                      display: 'inline-block',
                      marginBottom: '1rem',
                    }}
                  >
                    ← Home
                  </Link>
                  <QuorumsPage />
                </>
              }
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
      </div>
      <Footer />
    </>
  </BrowserRouter>
);
